// Validate the raw value before converting, so an empty input never becomes zero.
export function validateProductPrice(value) {
  const text = String(value ?? "").trim();
  if (!text) return "请填写商品价格。";
  if (!/^\d+(?:\.\d{1,2})?$/.test(text))
    return "价格必须为非负数字，最多两位小数。";
  const price = Number(text);
  if (!Number.isFinite(price) || price > Number.MAX_SAFE_INTEGER / 100)
    return "价格超出可支持范围。";
  return "";
}
